import { render, staticRenderFns } from "./StatementsBlock.vue?vue&type=template&id=6d2ef85a&scoped=true&"
import script from "./StatementsBlock.vue?vue&type=script&lang=ts&"
export * from "./StatementsBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ef85a",
  null
  
)

export default component.exports